import React from "react";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { FormControl, MenuItem, Checkbox, ListItemText } from "@mui/material";

interface Option {
  value: string;
  label: string;
}

interface ReportDropdownProps {
  options: Option[];
  placeholder?: string;
  value?: string[];
  onChange: (selected: Option[] | null) => void;
}

function ReportDropdown({
  options,
  placeholder = "Select an option",
  value = [],
  onChange,
}: ReportDropdownProps) {
  const taskValues = options.slice(1).map((opt) => opt.value);

  const handleChange = (event: SelectChangeEvent<string[]>) => {
    const selectedValues = event.target.value as string[];

    // Check if "All Tasks" was clicked
    if (selectedValues.includes("")) {
      const allSelected = value.length === taskValues.length;
      if (allSelected) {
        // Clear all
        onChange([]);
      } else {
        // Select all tasks
        onChange(options.slice(1)); // skip All Tasks
      }
      return;
    }

    // Otherwise, normal selection/unselection
    const newSelectedOptions = options.slice(1).filter((opt) =>
      selectedValues.some(
        (v) => v.toLowerCase() === opt.value.toLowerCase()
      )
    );

    onChange(newSelectedOptions.length ? newSelectedOptions : []);
  };



  return (
    <div>
      <FormControl
        sx={{
          minWidth: 352,
          width: "352px",
          color: "#DEDEDE",
          background: "#fff !important",
          height: "56px",
          padding: "14px 0",
          borderRadius: "8px",
          fontWeight: "500",
          border: "1px solid rgb(212 212 212)",
          justifyContent: "center",
          backgroundColor: "#FFF",
          "@media (max-width: 1366px)": {
            width: "250px",
            minWidth: 250,
          },
          "@media (max-width: 1280px)": {
            width: "240px",
            minWidth: 250,
          }
        }}
      >
        <Select
          sx={{
            height: "56px",
            color: "rgba(40, 40, 41, 1)",
            fontSize: "16px",
            fontWeight: "6 00",
            borderRadius: "4px",
            width: "345px",
            background: "#fff !important",
            "@media (max-width: 1366px)": {
              width: "245px",
            },
            "@media (max-width: 1280px)": {
              width: "247px",

            },


            "& .MuiOutlinedInput-notchedOutline": {
              borderRadius: "4px",
              border: "none",
            },
            "& .MuiSelect-icon": {
              borderRadius: "4px",
              fontSize: "30px",
              color: "var(--Icon-Colour, #5E5E5E)",
            },
            "& .MuiSelect-select": {
              borderRadius: "4px",
              padding: "4px 15px",
            },
          }}
          value={value.includes("") ? [...value, ""] : value} // Ensure "All Tasks" state is controlled
          onChange={handleChange}
          multiple
          displayEmpty
          renderValue={(selected) => {
            if (!selected.length) return placeholder;
            return options
              .filter((opt) =>
                selected.some(v => v.toLowerCase() === opt.value.toLowerCase())
              )
              .map((opt) => opt.label)
              .join(", ");
          }}

          inputProps={{ "aria-label": "Without label" }}
          IconComponent={ExpandMoreIcon}
        >
          <MenuItem value="" disabled>
            {placeholder}
          </MenuItem>
          {options.map((option) => (
            <MenuItem key={option.value} value={option.value}>

              <Checkbox
                checked={
                  option.value === ""
                    ? value.length === taskValues.length
                    : value.some(v => v.toLowerCase() === option.value.toLowerCase())
                }


                sx={{ marginRight: "8px", height: "16px", width: "16px" }}
              />
              <ListItemText
                primary={option.label}
                sx={{ padding: "0px" }}
              />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
}

export default ReportDropdown;